<header class="header">
  <div class="logo-container">
    <a routerLink="/">
      <img src="/assets/img/resolve-logo-black.png" alt="Resolve" />
    </a>
    <div class="subtitle">Practice Portal</div>
  </div>

  @if(profile){
    <app-header-nav 
      [profile]="profile"      
      (logoutClicked)="logout()">
    </app-header-nav>
  }
</header>

<main>
  <router-outlet></router-outlet>
  <app-loading-screen></app-loading-screen>
</main>

<footer>
  <app-footer-nav-menu></app-footer-nav-menu>
</footer>
